import { render } from "./SettingsViewV2.vue?vue&type=template&id=1cebfad0"
import script from "./SettingsViewV2.vue?vue&type=script&lang=js"
export * from "./SettingsViewV2.vue?vue&type=script&lang=js"

import "./SettingsViewV2.vue?vue&type=style&index=0&id=1cebfad0&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__